export enum KycMode {
    OKYC,
    Scan,
    Appointment,
}

export const currentAddressProofOptions = [
    {
        name: "Select type",
        value: "",
    },
    {
        name: "Driving License",
        value: "DL",
    },
    {
        name: "Aadhaar",
        value: "AADHAAR",
    },
    {
        name: "Voter Id",
        value: "VOTER_ID",
    },
    {
        name: "Passport",
        value: "PASSPORT",
    },
];

export const kycModeButtons = {
    OKYC: {
        name: KycMode.OKYC,
        value: "Aadhaar based KYC",
        description: "Verify Aadhaar in 3 mins with mobile OTP - Quick approval",
    },
    Scan: {
        name: KycMode.Scan,
        value: "Digital KYC",
        description: "Upload KYC Document",
    },
    Appointment: {
        name: KycMode.Appointment,
        value: "Physical Documents",
        description: "Agent assignment subject to feasibility",
    },
};

export enum DocUploadModes {
    SCAN_UPLOAD = "SCAN_UPLOAD",
    OKYC = "OKYC",
}

export enum UPLOAD_SIDE {
    FRONT = "FRONT",
    BACK = "BACK",
}

export enum KycInvoker {
    LOAN_APPLICATION = "LOAN_APPLICATION",
    INCOMPLETE_INFO = "INCOMPLETE_INFO",
}
